import { Toolbar, Button, List, Datagrid, TextField, useListContext, DateField } from 'react-admin';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

const resource = 'Profile';
const CompanyPagination = () => {
    const { page, perPage, total, setPage } = useListContext();
    const nbPages = Math.ceil(total / perPage) || 1;
    const pages = Object.keys(localStorage.getItem(`${resource}tokenObj`) ? JSON.parse(localStorage.getItem(`${resource}tokenObj`)) : [])
    return (
        nbPages > 1 &&
        <Toolbar>
            {page > 1 &&
                <Button color="primary" key="prev" onClick={() => setPage(page - 1)} >
                    <ChevronLeft />
                        Prev
                    </Button>
            }
            {
            page && pages.map((key,page) => {
                return (<Button color="primary" key={key} onClick={() => setPage(page+1)}>
                    {page+1}
                </Button>)
            })
            }
            {page !== nbPages &&
                <Button color="primary" key="next" onClick={() => setPage(page + 1)}>
                    Next
                        <ChevronRight />
                </Button>
            }
        </Toolbar>
    );
}

export const ProfileList = props => {
    return (
        <List  {...props} title={"Companies"} perPage={10} pagination={<CompanyPagination />} 
            exporter={false} >
            <Datagrid rowClick="show" bulkActionButtons={false} optimized>
                <TextField label="Company" source="name" sortable={false} />
				<TextField source="Description" sortable={false} />
                <DateField source="CreationDate" sortable={false} showTime={true}/>
                <DateField source="LastModifiedDate" sortable={false} showTime={true}/>
                <Button label="Edit" color="primary" icon="Edit" />
            </Datagrid>
        </List>
    )
};